export default "__VITE_ASSET__80d814fe__"